module.exports = __webpack_public_path__ + "static/about_us-bccc73c96668cdadb9ff650656845715.svg";